export const environment = {
  production: true,
  apiUrl: 'https://waleedalmarhoon.com/backend/api/',
  productAdd: 'product/add/',
  productList: 'product/list/',
  productDelete: 'product/delete/',
  storeTotals: 'stores/totals/',
  stockAdd: 'stock/add',
  stockList: 'stock/list/',
  stockMove: 'stock/move/',
  customerList: 'customer/list/',
  customerAdd: 'customer/add/',
  expenseAdd: 'transaction/addExpense',
  transactionList: 'transaction/list',
  stockView: 'stock/view',
  stockTotals: 'stock/totals',
  expenseDelete: 'transaction/expenseDelete',
  saleAdd: 'sale/add',
  saleList: 'sale/list/',
  productSaleList:'sale/saleproduct/',
  saleDelete: 'sale/delete',
  customerDelete: 'customer/delete',
  userRegister: 'user/register',
  userLogin: 'user/login',
  saleTotal: 'sale/totals',
  transactionTotal: 'transaction/totals',
  userList: 'user/list',
  userGet:"user/get/",
  userGetModules:"user/get_modules/",
  productSaleTotal:'sale/productsaletotals/',
  userGetStores:"user/get_stores/",
  userStatus: 'user/setstatus',
  userDelete: 'user/delete',
  userAdmin: 'user/isadmin',
  salesCreditPay: 'sale/pay_credit',
  storeAdd:"stores/add",
  storeList:"stores/list/",
  storeGet:"stores/get/",
  storeDelete:"stores/delete/",
  quantityAdd:"stock/add",
  modules:"modules/list",
  productGet:"product/get/",
  saleReturn:"sale/return/",
  customerAreaAdd:"customer/area_add/",
  customerArea:"customer/area/",
  customerAreaDelete:"customer/area_delete/",
  transactionListBySale: 'transaction/listById/',
  isAdmin: false,
  isModules:[]
};
